import { render, staticRenderFns } from "./CadastroOfertaDimensoes.vue?vue&type=template&id=2340bdd9"
import script from "./CadastroOfertaDimensoes.vue?vue&type=script&lang=js"
export * from "./CadastroOfertaDimensoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports